<template>
  <Select
    v-model="selected"
    placement="bottom-start"
    filterable
    clearable
    transfer
    :default-label="name"
    :disabled="disabled"
    :remote-method="searchManufacterPart"
    :placeholder="$t('part.part_search_input_placeholder')"
    :loading="loading"
    @on-clear="handleClear"
    @on-change="handleManufacterPartSelect">
    <Option
      v-for="item in manufacturerParts"
      :value="item.id" :key="'mp_' + item.id"
      :label="manufacturerPartLabel(item, item.part_identity ? item.part_identity.part_number : null)"
      class="mp-select-row">
      <p><strong>{{ `${item.mpn || ''} ${item.brand || ''} ${item.name}, ${item.chinese_name}` }}</strong></p>
      <p style="color: #9ea7b4; font-size: 12px; margin: 2px 0;">{{ item.specification }}</p>
      <p v-if="item.part_identity" style="margin-top: 5px;">{{ item.part_identity.part_number }}</p>
    </Option>
  </Select>
</template>

<script>
import { eloquentsearch } from '@/api/search'
export default {
  name: 'ManufacturerPartPicker',
  props: {
    value: {
      type: Number
    },
    label: {
      type: [String, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      loading: false,
      selected: null,
      manufacturerParts: []
    }
  },
  mounted() {
    this.selected = this.value
  },
  methods: {
    manufacturerPartLabel(manufacturerPart, partNumber = null) {
      if (manufacturerPart) {
        let values = _.filter(_.valuesIn(_.pick(manufacturerPart, ['name', 'chinese_name', 'mpn', 'brand'])))
        return `${values.join(', ')} ${partNumber ? '(' + partNumber + ')' : ''}`
      } else {
        return null
      }
    },
    searchManufacterPart (keyword) {
      this.loading = true
      eloquentsearch('manufacturer_part', keyword)
        .then(resp => {
          this.manufacturerParts = resp.data.data
          if (this.value) {
            this.selected = this.value
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleManufacterPartSelect (manufacturerPartId) {
      if (manufacturerPartId) {
        let manufacturerPart = _.find(this.manufacturerParts, (item) => {
          return item.id === manufacturerPartId
        })

        this.$emit('input', manufacturerPartId)
        this.$emit('update:manufacturerPart', manufacturerPart)
        this.$emit('on-changed', manufacturerPart)
      }
    },
    handleClear () {
      this.$emit('input', null)
      this.$emit('update:manufacturerPart', null)
    }
  },
  watch: {
    value (val) {
      this.selected = this.value
    }
  }
}
</script>

<style lang="less">

  .mp-select-row {
    max-width: 720px;
    overflow: hidden;
    font-size: 10px;
    word-wrap: break-word;

    .mp-specification {
      color: gray;
    }
    .mp-attributes {
      padding-right: 5px;
      min-width: 128px;
    }
  }
  .part-form-drawer {
    .ivu-drawer-wrap {
      z-index: 1200;
    }
  }
</style>
